<script>
//  import Layout from '@layouts/Main'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  //   components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
  beforeDestroy() {
    var doc = this.$refs.session
    if (doc !== undefined) doc.innerHTML = ''
  },
}
</script>

<template>
  <section ref="session">
    <div class="container">
      <div
        :class="$style.rowAlign"
        class="row align-items-center justify-content-center"
      >
        <div class="col-12">
          <div :class="$style.notFoundWraper">
            <div :class="$style.fileNotfount">
              <img src="@assets/images/404.png" alt="404" />
              <div :class="$style.eyeBall">
                <img
                  src="@assets/images/eye.png"
                  class="w100"
                  alt="404 eyeball"
                />
              </div>
            </div>
            <h3 class="">Page not found..!</h3>
            <p :class="$style.title">The requested page is not exist.</p>
            <div class="tc mt5 mt10-sm">
              <button
                :class="$style.createButton"
                class=""
                onCLick="history.back()"
                >Go Back</button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <h1 :class="$style.title">
            The page timed out while loading. Are you sure you're still connected to
            the Internet?
        </h1> -->
  </section>
</template>

<style lang="scss" module>
@import '@design';

.title {
  margin: 20px 0;
  font-family: 'SourceSansProSemiRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 20px;
  color: $primary-font-color;
  text-align: center;
}

.rowAlign {
  height: 100vh;
}

.fileNotfount {
  position: relative;
  width: 700px;
  margin: 0 auto;
  animation: shake 0.2s;
}

.eyeBall {
  position: absolute;
  top: 93px;
  left: 304px;
  width: 80px;
  animation-name: move-eye-skew;
  animation-duration: 3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.notFoundWraper {
  h4 {
    margin: 0;
    font-size: 100px;
    font-weight: bold;
    line-height: 100px;
    color: #f76b78;
    text-align: center;
  }

  h3 {
    margin: 20px 0 0;
    font-size: 50px;
    font-weight: bold;
    line-height: 50px;
    color: #f7936b;
    text-align: center;
  }

  img {
    width: 100%;
  }
}

.createButton {
  position: relative !important;
  padding: 5px 20px !important;
  font-family: 'SourceSansProRegular', Helvetica Neue, sans-serif,
    Apple Color Emoji;
  font-size: 16px !important;
  color: #fff;
  background-color: $primary-color;
  border: 2px solid $primary-color;
  border-radius: 50px !important;
  transition: all ease-in-out 0.3s;

  &:hover {
    background-color: $primary-color-dark;
    border: 2px solid $primary-color-dark;
    transition: all ease-in-out 0.3s;
  }
}

@keyframes move-eye-skew {
  0% {
    transform: none;
  }

  10% {
    transform: translateX(-30px) translateY(0) scale(0.9) scaleY(0.95);
  }

  15%,
  44% {
    transform: none;
  }

  50%,
  60% {
    transform: translateX(30px) translateY(0) scale(0.9) scaleY(0.95);
  }

  66%,
  100% {
    transform: none;
  }
}

@media only screen and (max-width: 767px) {
  .notFoundWraper {
    h4 {
      font-size: 50px;
      line-height: 50px;
    }

    h3 {
      font-size: 20px;
      line-height: 20px;
    }
  }

  .title {
    margin: 5px;
    font-size: 15px;
  }

  .fileNotfount {
    width: 200px;
  }

  .eyeBall {
    top: 28px;
    left: 90px;
    width: 20px;
  }

  @keyframes move-eye-skew {
    0% {
      transform: none;
    }

    10% {
      transform: translateX(-10px) translateY(0) scale(0.9) scaleY(0.95);
    }

    15%,
    44% {
      transform: none;
    }

    50%,
    60% {
      transform: translateX(10px) translateY(0) scale(0.9) scaleY(0.95);
    }

    66%,
    100% {
      transform: none;
    }
  }
}
</style>
